<!--
 * @Author: DT
 * @Date: 2023-02-20 11:36:14
 * @LastEditors: DT
 * @LastEditTime: 2023-02-22 10:26:45
 * @Description: file content
 * @FilePath: /yxdcommunity/src/components/yzg/shareButton.vue
-->

<template>
  <div
    @click="handleShare"
    :class="{ is_width: isWidth }"
    :data-stat="'接龙分享_' + activityId"
  >
    <slot name="button"></slot>
  </div>
</template>

<script>
import { getShareURL } from "@/libs/api.js";
import { uleUrl } from "@/libs/common";
export default {
  name: "editGroup",

  props: {
    shareName: {
      type: String,
      default: () => "",
    },
    activityId: {
      type: String,
      default: () => "",
    },
    shareImg: {
      type: String,
      default: () => "",
    },
    isWidth: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleShare() {
      let data = {
        shareName: this.shareName,
        clientCallType: "H5",
        shareType: "59",
        shareChannel: "11",
        subType: "7",
        shareLink: `https://h5.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${
          this.activityId
        }`,
        unionRef: this.activityId,
      };
      console.log("分享====", data);
      this.$emit("toggle", false, "middle");
      getShareURL(data).then((res) => {
        let shareData = res.data;
        console.log("shareData====", shareData);
        let MinType = 0;
        if (uleUrl().indexOf("testing") > -1 || uleUrl().indexOf("beta") > -1) {
          MinType = 2;
        }
        let baseData = {
          listName: this.shareName,
          listImage: [this.shareImg],
          shareCommission: 0,
          shareTitle: `您的好友邀请您参与接龙：${this.shareName}`,
          shareContent: `您的好友邀请您参与接龙：${this.shareName}`,
          WXMiniProgram_Type: MinType, // 0正式版，1测试版 2体验版
          WXMiniProgram_DialogName: "微信好友",
          WXMiniProgram_userName: "gh_1e6276474cf7",
          WXMiniProgram_Title: `您的好友邀请您参与接龙：${this.shareName}`,
          WXMiniProgram_pageUrl: shareData.shareUrl3,
          WXMiniProgram_path:
            "pages/index/index?targetUrl=" +
            encodeURIComponent(shareData.shareUrl3),
          WXMiniProgram_OriginalId: "gh_1e6276474cf7",
          WXMiniProgram_image: this.shareImg,
          canShareOkCallBack: true,
          ruleDescription: "",
          imageBanner: this.shareImg,
        };
        let shareObj = this.objectassign({}, baseData, shareData, {
          listId: this.activityId,
          sharePrice: 0,
          marketPrice: 0,
          shareFrom: "0",
        });
        shareObj.shareOptions = "4##1";
        shareObj.shareUrl = shareObj.shareUrl4 || shareObj.shareUrl3;
        console.log("app弹出分享参数", shareObj);

        if (window.dsBridge) {
          window.dsBridge.call("generalAction", {
            type: "2",
            ios_action: JSON.stringify(shareObj),
            android_action: JSON.stringify(shareObj),
            maxversion: "999&999",
            needlogin: "false",
          });
        } else {
          window.location.href =
            "uleMobile://uleShare_" +
            encodeURI(shareObj.shareTitle) +
            "##" +
            encodeURI(shareObj.shareContent) +
            "##" +
            shareObj.listImage +
            "##" +
            shareObj.shareUrl +
            "##" +
            shareObj.shareContent;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.is_width {
  width: 100%;
}
</style>
